$(".equestrian-three-images__smallTwo.slider-index--1 .product-grid__listing").slick({
  vertical: false,
  slidesToShow: 2,
  nextArrow: '.slider-index--1 .nextArrow-slider',
  prevArrow: '.slider-index--1 .prevArrow-slider'
})

$(".equestrian-three-images__smallTwo.slider-index--2 .product-grid__listing").slick({
  vertical: false,
  slidesToShow: 2,
  nextArrow: '.slider-index--2 .nextArrow-slider',
  prevArrow: '.slider-index--2 .prevArrow-slider'
})

$(".equestrian-three-images__smallTwo.slider-index--3 .product-grid__listing").slick({
  vertical: false,
  slidesToShow: 2,
  nextArrow: '.slider-index--3 .nextArrow-slider',
  prevArrow: '.slider-index--3 .prevArrow-slider'
})


// $( window ).resize(function() {
//   if($(window).width() < 767.98) {
//     $(".equestrian-three-images__smallTwo--mobile .product-grid__listing").each(function(index){
//       $(this).slick("refresh")
//     })
//   }
// });